import {
  FETCH_PROVEEDORES_REQUEST,
  FETCH_PROVEEDORES_SUCCESS,
  FETCH_PROVEEDORES_FAILURE,
} from "../actions/proveedores/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROVEEDORES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PROVEEDORES_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_PROVEEDORES_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
